/**
 *
 * @source: https://github.com/fightforthefuture/savesecurity.org
 *
 * @licstart  The following is the entire license notice for the
 *  JavaScript code in this page.
 *
 * Copyright (C) Fight for the Future
 *
 *
 * The JavaScript code in this page is free software: you can
 * redistribute it and/or modify it under the terms of the GNU
 * General Public License (GNU GPL) as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option)
 * any later version.  The code is distributed WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE.  See the GNU GPL for more details.
 *
 * As additional permission under GNU GPL version 3 section 7, you
 * may distribute non-source (e.g., minimized or compacted) forms of
 * that code without the copy of the GNU GPL normally required by
 * section 4, provided you include this license notice and a URL
 * through which recipients can access the Corresponding Source.
 *
 * @licend  The above is the entire license notice
 * for the JavaScript code in this page.
 *
 */

/**
 *  util : random grab bag functions
 */

var $c  = document.createElement.bind(document);
var $el = document.getElementById.bind(document);

util = {
  getReferrerTag: function() {
    var ref = document.referrer;
    if (ref.indexOf('facebook.com') !== -1)
      return 'from-facebook';
    else if (ref.indexOf('twitter.com') !== -1 || ref.indexOf('t.co') !== -1)
      return 'from-twitter';
    else if (ref.indexOf('reddit.com') !== -1)
      return 'from-reddit';
    else if (window.location.href.indexOf('_src=ga') !== -1)
      return 'from-google-adwords';
    else if (ref.indexOf('google.com') !== -1)
      return 'from-google';
  }
}

window.components = window.components || {};
window.components.forms = function (doc, win) {
  /**
   * Retrieves form data from Action Network API, then submits entry
   * @param {object} doc - Document object
   * @param {object} win - Window object
   * */
  "use strict";

  var
    body = doc.getElementsByTagName('body')[0],
    submitButton = body.querySelector('[type="submit"]'),
    submitted = doc.createElement('div'),
    countryLabel = doc.querySelector('[for="select-country"]'),
    countrySelect = doc.getElementById('select-country'),
    countryInput = doc.getElementById('hidden-country'),
    formComments = doc.getElementById('form-comments'),
    commitmentForm = doc.forms[0];

  submitted.classList.add('submitted');
  submitted.innerHTML = '<div class="circle-spinner">&nbsp;</div>';

  function focusComments() {
    formComments.className = 'focused';
  }

  function updateZIPPlaceholder() {
    /**
     * Updates placeholder on ZIP/Post Code field to be appropriate for country
     * selected
     * */
    var
      ZIPLabel = doc.getElementById('form-zip_code');

    if (countrySelect.value !== 'US') {
      ZIPLabel.setAttribute('placeholder', 'Post code');
    } else {
      ZIPLabel.setAttribute('placeholder', 'ZIP');
    }
  }

  function toggleCountryField() {
    /**
     * Hides the label and shows the select when someone changes their signature
     * country.
     * */

    countryInput.remove();
    countrySelect.setAttribute('name', 'answer[country]');
    countrySelect.classList.add('visible');
    countryLabel.classList.add('hidden');
  }

  function removeForm() {
    commitmentForm.setAttribute('style', 'height: ' + commitmentForm.clientHeight + 'px;');
    win.setTimeout(function(){
      commitmentForm.setAttribute('style', 'height: 0;');
    }, 20)
  }

  function handleSigningError(e) {
    /**
     * Figures out what to say at just the right moment
     * @param {event|XMLHttpRequest} e - Might be an event, might be a response
     * from an XMLHttpRequest
     * */

    var
      errorMessage = doc.createElement('h2'),
      errorMessageInfo = doc.createElement('p');

    commitmentForm.removeAttribute('disabled');
    submitted.remove();
    errorMessage.textContent = 'Something went wrong';
    if (e.type) {
      errorMessageInfo.textContent = 'There seems to be a problem somewhere in between your computer and our server. Might not be a bad idea to give it another try.';
    } else if (e.status) {
      errorMessageInfo.textContent = '(the nerdy info is that the server returned a status of "' + e.status + '" and said "' + e.statusText + '".)'
    } else {
      errorMessageInfo.textContent = 'this seems to be a weird error. the nerds have been alerted.';
    }

    win.modals.generateModal([errorMessage, errorMessageInfo]);

    submitted.remove();
    submitButton.removeAttribute('disabled');
  }

  function handleSigningSuccess() {
    /**
     * Figures out what to say at just the right moment
     * @param {event|XMLHttpRequest} e - Might be an event, might be a response
     * from an XMLHttpRequest
     * */

    var
      modalContent = doc.createElement('div'),
      share = doc.getElementsByClassName('share')[0];

    console.log('share:' ,share);

    share.classList.add('visible');
    modalContent.innerHTML = '<h2>Thanks for signing</h2>\n<p>Now, share this page to spread the word.</p><ul class="share inline visible">\n'+share.innerHTML+'</ul><p><small>…or, <a href="https://donate.fightforthefuture.org/?amount=5&frequency=just-once">donate $5</a> to help us spread the message.</small></p>';

    win.modals.generateModal([modalContent]);
    removeForm();

    document.querySelector('.modal-content button.facebook').addEventListener('click', FreeProgress.share.bind(FreeProgress));
    document.querySelector('.modal-content button.google').addEventListener('click', googlePlus);
    document.querySelector('.modal-content button.twitter').addEventListener('click', FreeProgress.tweet.bind(FreeProgress));
  }

  function submitForm(event) {
    /**
     * Submits the form to ActionNetwork.
     * @param {event} event - Form submission event
     * */

    event.preventDefault();

    var
      commitmentStatus = new XMLHttpRequest();

    commitmentForm.setAttribute('disabled', true);
    submitted.classList.add('submitted');
    submitButton.setAttribute('disabled', true);
    commitmentForm.appendChild(submitted);

    function compilePayload() {
      /**
       * Compiles the form data into a JSON payload for Ajax submission
       * @return {object} petitionFormData - just the info the API needs
       * */

      var tags = JSON.parse(doc.querySelector('[name="subscription[tag_list]"]').value);
      if (util.getReferrerTag())
        tags.push(util.getReferrerTag());

      var formData = new FormData();
      formData.append('guard', '');
      formData.append('hp_enabled', true);
      formData.append('org', 'fftf');
      formData.append('tag', window.location.pathname);

      formData.append('an_tags', JSON.stringify(tags));
      formData.append('an_petition', commitmentForm.action.replace('/signatures', ''));

      formData.append('member[email]', doc.getElementById('form-email').value);
      formData.append('member[postcode]', doc.getElementById('form-zip_code').value);
      formData.append('member[country]', countrySelect.value);

      if (doc.getElementById('form-first_name')) {
        formData.append('member[first_name]', doc.getElementById('form-first_name').value);
      }

      if (doc.getElementById('form-comments')) {
        formData.append('action_comment', doc.getElementById('form-comments').value);
      }

      return formData;
    }

    function loadSignatureResponse() {
      /**
       * Does the thing after we get a response from the API server
       * */

      if (commitmentStatus.status >= 200 && commitmentStatus.status < 400) {
        handleSigningSuccess();
      } else {
        handleSigningError(commitmentStatus);
      }
    }

    commitmentStatus.open('POST', 'https://queue.fightforthefuture.org/action', true);
    commitmentStatus.addEventListener('error', handleSigningError);
    commitmentStatus.addEventListener('load', loadSignatureResponse);
    commitmentStatus.send(compilePayload());

    /*
    var data = new FormData();
    data.append('name', doc.getElementById('form-first_name').value);
    data.append('comment', doc.getElementById('form-comments').value);

    var xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function() {
        if (xhr.readyState === 4)
        {
            if (xhr.status == 200)
                console.log('SUCCESS:', xhr.response);
            else
                console.log('FAIL:', xhr.response);
        }
    }.bind(this);
    xhr.open("post", 'https://queue.fightforthefuture.org/stuff_regulations_gov', true);
    xhr.send(data);
    */

    if (typeof ga !== 'undefined' && typeof window.VARIATION !== 'undefined') {
      console.log('event', 'form', 'convert', window.VARIATION);
      ga('send', 'event', 'form', 'convert', window.VARIATION);
    }
  }

  function addEventListeners() {
    /**
     * Attaches all the listeners all the places
     * */
    countryLabel.addEventListener('click', toggleCountryField);
    countrySelect.addEventListener('change', updateZIPPlaceholder);
    commitmentForm.addEventListener('submit', submitForm);
    formComments.addEventListener('focus', focusComments);
  }

  function init() {
    addEventListeners();
  }

  init();
  // setTimeout(function() { handleSigningSuccess() }, 500); // JL DEBUG ~
};

(function (doc, win) {
  "use strict";

  win.modals = win.modals || {};

  var
    i,
    body = doc.getElementsByTagName('body')[0],
    modalParent = doc.createElement('div');

  modalParent.classList.add('modal-parent', 'fade-in');

  function dismissModal() {
    /**
     * Removes modal from DOM
     * */

    var
      modal = doc.getElementsByClassName('modal-content')[0];

    doc.getElementsByClassName('overlay')[0].remove();
    modal.removeAttribute('style');
    modal.classList.add('off-screen');
    win.setTimeout(function () {
      modal.remove();
    }, 420);
  }

  function generateModal(contents, disableOverlayClick) {
    /**
     * Triggers a modal
     *
     * @param {node} contents - any HTML to be used as modal content (also
     *   accepts array of nodes)
     * @param {boolean} disableOverlayClick - if false (or absent), function
     *   adds event listener to allow dismissal of modal by clicking on
     *   overlay.
     * */

    var
      overlay = doc.createElement('div'),
      modal = doc.createElement('div'),
      closeModal;

    if (contents.length === undefined) {
      contents = [contents];
    }

    if (typeof disableOverlayClick !== 'boolean') {
      disableOverlayClick = false;
    }

    overlay.id = disableOverlayClick ? 'no-click-for-you' : 'dismiss-me';
    overlay.classList.add('overlay');
    modal.classList.add('modal-content');

    if (!disableOverlayClick) {
      closeModal = doc.createElement('button');
      closeModal.classList.add('close-modal');
      closeModal.innerHTML = '&times;';
      modal.appendChild(closeModal);
      closeModal.addEventListener('click', dismissModal);
      overlay.addEventListener('click', dismissModal);
    }

    for (i = 0; i < contents.length; i++) {
      modal.appendChild(contents[i]);
    }

    modalParent.appendChild(overlay);
    modalParent.appendChild(modal);
    body.appendChild(modalParent);

    win.setTimeout(function () {
      modalParent.classList.remove('fade-in');
    }, 500);
  }

  function noConnectionModal() {
    /**
     * noConnectionModal();
     * Triggers a modal which reads:
     * > Something went wrong.
     * > Do you have a network connection?
     * */

    dismissModal();
    var
      message = doc.createElement('h2');

    message.innerHTML = 'Something went wrong.<br />Do you have a network connection?';
    generateModal([message]);
  }

  win.modals.dismissModal = dismissModal;
  win.modals.generateModal = generateModal;
  win.modals.noConnectionModal = noConnectionModal;


}(document, window));



/******************** *
 * FFTF Donate Modals *
 ******************** */
(function (doc, win) {
  "use strict";

  win.modals = win.modals || {};

  var
    i,
    body = doc.getElementsByTagName('body')[0],
    modalParent = doc.createElement('div');

  modalParent.classList.add('modal-parent');

  function dismissModal() {
    /**
     * Removes modal from DOM
     * */

    var
      modal = doc.getElementsByClassName('modal-parent')[0];

    modal.setAttribute('style', 'opacity: 0');

    win.setTimeout(function () {
      modal.remove();
    }, 420);
  }

  function generateModal(contents, disableOverlayClick) {
    /**
     * Triggers a modal
     *
     * @param {node} contents - any HTML to be used as modal content (also
     *   accepts array of nodes)
     * @param {boolean} disableOverlayClick - if false (or absent), function
     *   adds event listener to allow dismissal of modal by clicking on
     *   overlay.
     * */

    var
      overlay = doc.createElement('div'),
      modal = doc.createElement('div'),
      closeModal;

    if (contents.length === undefined) {
      contents = [contents];
    }

    if (typeof disableOverlayClick !== 'boolean') {
      disableOverlayClick = false;
    }

    overlay.id = disableOverlayClick ? 'no-click-for-you' : 'dismiss-me';
    overlay.classList.add('overlay');
    modal.classList.add('modal-content', 'off-screen');

    if (!disableOverlayClick) {
      closeModal = doc.createElement('button');
      closeModal.classList.add('close-modal');
      closeModal.innerHTML = '&times;';
      modal.appendChild(closeModal);
      closeModal.addEventListener('click', dismissModal);
      overlay.addEventListener('click', dismissModal);
    }

    for (i = 0; i < contents.length; i++) {
      modal.appendChild(contents[i]);
    }

    modalParent.appendChild(overlay);
    modalParent.appendChild(modal);
    body.appendChild(modalParent);

    win.setTimeout(function () {
      modal.classList.remove('off-screen');
    }, 50);
  }

  function noConnectionModal() {
    /**
     * noConnectionModal();
     * Triggers a modal which reads:
     * > Something went wrong.
     * > Do you have a network connection?
     * */

    dismissModal();
    var
      message = doc.createElement('h2');

    message.innerHTML = 'Something went wrong.<br />Do you have a network connection?';
    generateModal([message]);
  }

  win.modals.dismissModal = dismissModal;
  win.modals.generateModal = generateModal;
  win.modals.noConnectionModal = noConnectionModal;


}(document, window));

(function (doc, win) {
  win.views = win.views || {};
  win.views.modals = {}}(document, window));

var $c  = document.createElement.bind(document);

function googlePlus() {
  var url = window.location.protocol + '//' + window.location.host;
  window.open('https://plus.google.com/share?url='+url, 'share_gl', 'width=500, height=300, toolbar=no, status=no, menubar=no');
}

(function (doc, win) {
  "use strict";

  if (!document.getElementById('save-fair-use'))
    return false;

  function triggerComponents() {
    win.components = win.components || {};
    var
      i = 0,
      components = doc.getElementsByTagName('body')[0].dataset.components;

    if (components !== undefined) {
      components = components.split(' ');
      i = components.length;

      while (i--) {
        if (components[i] !== '' && win.components[components[i]] !== undefined) {
          win.components[components[i]](doc, win);
        }
      }
    }
  }

  triggerComponents();

  var shareVisibilityTriggered = false;
  var headlineEl  = document.getElementById('save-fair-use'),
      bodyRect    = document.body.getBoundingClientRect(),
      elemRect    = headlineEl.getBoundingClientRect(),
      headlineY   = elemRect.top - bodyRect.top;

  var listenerFn = function() {
    var top   = ((window.pageYOffset||doc.scrollTop)-(doc.clientTop||0)||0),
        alpha = 1-(top/headlineY);

    if (alpha < 0) alpha = 0;

    document.body.style.backgroundColor = 'rgba(15,22,32,'+alpha+')';


    if (top > 300 && shareVisibilityTriggered == false) {
      shareVisibilityTriggered = true;
      document.querySelector('ul.share').classList.add('visible');
    }
  };

  /*
  // JL HACK ~ disable countdown
  if (typeof window.VARIATION === 'undefined' || window.VARIATION == 'splash') {
    listenerFn();
    window.addEventListener('scroll', listenerFn);
  }


  doc.querySelector('[href="#save-fair-use"]').addEventListener('click', function (e){
    e.preventDefault();

    win.smoothScroll(doc.getElementById('save-fair-use'));
  });
  */

  var gl = document.querySelectorAll('button.google');
    for (var i = 0; i < gl.length; i++) {
        gl[i].addEventListener('click', function(e) {
            e.preventDefault();
            googlePlus();
        }, false);
    }

  // COUNTDOWN TO FUN

  function Countdown() {
    this.date = new Date(Date.UTC(2016, 04, 12, 14, 00, 0)).getTime();
    this.interval = null;
    this.requestAnimationFrame = this.requestAnimationFrame.bind(this);
    this.targets = {};
    this.tick = this.tick.bind(this);
    this.curTick = false;
    this.start();
  }

  Countdown.prototype.constants = {
    day: (1000 * 60 * 60 * 24),
    hour: (1000 * 60 * 60),
    minute: (1000 * 60),
    second: (1000)
  };

  Countdown.prototype.padNumber = function(number) {
    if (number > 9) {
      return number;
    } else {
      return '0' + number;
    }
  };

  Countdown.prototype.requestAnimationFrame = function() {
    var request = window.requestAnimationFrame || setTimeout;
    request(this.tick);
  };

  Countdown.prototype.start = function() {
    this.stop();
    this.requestAnimationFrame();
    this.interval = setInterval(this.requestAnimationFrame, 1000);
  };

  Countdown.prototype.stop = function() {
    clearInterval(this.interval);
  };

  Countdown.prototype.tick = function() {
    var now = Date.now();
    var difference = this.date - now;

    this.updateDates(difference);

    if (difference < 0) {
      this.stop();
      document.getElementById('remaining').textContent = '00.00:00:00';
    }
  };

  Countdown.prototype.updateDates = function(difference) {

    this.curTick = !this.curTick;
    var c = this.curTick;

    var days = Math.floor(difference / this.constants.day);
    difference -= days * this.constants.day;

    var hours = Math.floor(difference / this.constants.hour);
    difference -= hours * this.constants.hour;

    var minutes = Math.floor(difference / this.constants.minute);
    difference -= minutes * this.constants.minute;

    var seconds = Math.floor(difference / this.constants.second);
    difference -= seconds * this.constants.second;

    /*
    var str =   this.padNumber(days)
    +(c ? '.' : '.')+this.padNumber(hours)
    +(c ? ':' : ' ')+this.padNumber(minutes)
    +(c ? ':' : ' ')+this.padNumber(seconds);
    */
    var str =   this.padNumber(days)
    +'.'+this.padNumber(hours)
    +':'+this.padNumber(minutes)
    +':'+this.padNumber(seconds);

    document.getElementById('remaining').textContent = str;
  };

  // new Countdown(); // JL HACK ~ disabled

  if (storyUrls) {

    var curIndex = Math.floor(Math.random() * storyUrls.length);

    var loadStory = function(prev) {
      if (!prev) {
        curIndex++;
        if (curIndex == storyUrls.length)
          curIndex = 0;
      } else {
        curIndex--;
        if (curIndex == -1)
          curIndex = storyUrls.length - 1;
      }

      var xhr = new XMLHttpRequest();
      var re = /\<\!\-\- BEGIN STORY \-\-\>(.|\n)*\<\!\-\- END STORY \-\-\>/mi

      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4) {
          var found = xhr.response.match(re);
          doc.getElementById('story').innerHTML = found[0];
          setTimeout(function() {
            doc.getElementById('story').style.opacity = 1;
          }, 50);
        }
      }.bind(this);
      xhr.open("get", storyUrls[curIndex], true);
      xhr.send();

    }

    loadStory();

    var storyFade = function(e, prev) {
      e.preventDefault();
      win.smoothScroll(doc.getElementById('dmca-horror-stories'));
      doc.getElementById('story').style.opacity = 0;
      setTimeout(function() {
        loadStory(prev);
      }, 500);
    }

    doc.getElementById('story-next').addEventListener('click', function(e) {
      storyFade(e, false);
    });
    doc.getElementById('story-prev').addEventListener('click', function(e) {
      storyFade(e, true);
    });

  }

})(document, window);

//# sourceMappingURL=core.js.map